import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'shared-ui';

import { fetchObecnoscStrefy } from 'api/strefy/strefy';
import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';

import { CurrentPresence } from './CurrentPresence';
import { PresenceLocationState, PresenceRefetchInterval } from './CurrentPresence.types';
import { toPresenceRefetchInterval } from './CurrentPresence.variables';

export const CurrentPresenceContainer = () => {
  const { state } = useLocation();
  const [refetchInterval, setRefetchInterval] = useState<PresenceRefetchInterval>(() =>
    toPresenceRefetchInterval((state as PresenceLocationState | null)?.refetchInterval),
  );

  const { data: presence, isLoading } = useQuery([QueryKeyEnum.OBECNOSC_STREFY], fetchObecnoscStrefy, {
    refetchInterval,
  });

  return (
    <ErrorBoundary>
      <CurrentPresence
        presence={presence}
        isLoading={isLoading}
        refetchInterval={refetchInterval}
        setRefetchInterval={setRefetchInterval}
      />
    </ErrorBoundary>
  );
};
